module.exports = __webpack_public_path__ + "static/media/SN.107462be.png";